import {Injectable} from '@angular/core';
import {MdDialog, MdDialogConfig} from '@angular/material';
import {EditableItemField} from '../../interfaces/EditableItemField';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/skipWhile';
import 'rxjs/add/operator/do';
import {AddItemDialogComponent} from '../../components/add-item-dialog/add-item-dialog.component';

@Injectable()
export class EditItemService {

  constructor(public dialog: MdDialog) {
  }

  /**
   * Launches the AddItemDialogComponent
   */
  openDialog(name: string, fields: EditableItemField[], item: any): Observable<any> {
    return this.dialog
      .open(AddItemDialogComponent, <MdDialogConfig> {data: {name: name, fields: fields, item: item}})
      .afterClosed()
      .skipWhile((result) => result === 'cancel' || result === undefined || result === null)
      .do(result => result);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/edit-item/edit-item.service.ts